import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import * as fallback from "../content/site";

const DEFAULTS = {
  hero_blurb: fallback.HERO_BLURB,
  tagline: fallback.BRAND.tagline,
  about_me: fallback.ABOUT_ME,
  what_to_expect: fallback.WHAT_TO_EXPECT,
  stats: fallback.STATS,
  personality_tags: fallback.PERSONALITY_TAGS,
  rates: fallback.RATES,
  included: fallback.INCLUDED,
  extras: fallback.EXTRAS,
  not_offered: fallback.NOT_OFFERED,
  deposit: fallback.DEPOSIT,
  faqs: fallback.FAQS,
  contact: {
    phone_display: fallback.CONTACT.phoneDisplay,
    phone_intl: fallback.CONTACT.phoneIntl,
    wa_number: fallback.CONTACT.waNumber,
  },
  onlyfans: fallback.BRAND.onlyfans,
  onlyfans_url: fallback.BRAND.onlyfans,
  handle: fallback.BRAND.handle,
  location_incall: fallback.LOCATION.incall,
  location_outcall: fallback.LOCATION.outcall,
  seo_title: "Camilla XXX — Sydney's Playful Turkish-Australian Tease",
  seo_description:
    "Independent Sydney escort. Turkish-Australian tease. Liverpool incalls, Sydney metro outcalls. GFE with a wild streak. Book on WhatsApp 💋",
};

const DEFAULT_SETTINGS = {
  available_now: true,
  after_hours_mode: false,
  banner: { enabled: false, text: "", link: null },
  testimonials: { enabled: false, items: [] },
};

const SiteContext = createContext({
  content: DEFAULTS,
  settings: { available_now: true, after_hours_mode: false },
  versions: {},
  reload: () => {},
});

export function SiteProvider({ children }) {
  const [content, setContent] = useState(DEFAULTS);
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [versions, setVersions] = useState({});

  const reload = useCallback(async () => {
    try {
      const [c, v] = await Promise.all([
        api.content().catch(() => null),
        api.imageVersions().catch(() => ({})),
      ]);
      if (c && c.content) {
        setContent({ ...DEFAULTS, ...c.content });
        setSettings({ ...DEFAULT_SETTINGS, ...(c.settings || {}) });
      }
      setVersions(v || {});
    } catch (e) {
      // keep defaults
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return (
    <SiteContext.Provider value={{ content, settings, versions, reload }}>
      {children}
    </SiteContext.Provider>
  );
}

export function useSite() {
  return useContext(SiteContext);
}
